import { ref, watch } from "vue";

export const lessMore = {
    mounted(el, binding) {
        const limit = parseInt(binding.value || 120);
        const text = el.innerHTML;

        const excerpt = ref("");
        const showMore = ref(false);

        if (text.length > limit) {
            excerpt.value = text.slice(0, limit) + "...";
            el.innerHTML = excerpt.value;
        }

        el.insertAdjacentHTML("afterend", "<button>more</button>");

        const btnElement = el.nextSibling;
        btnElement.style.backgroundColor = "none";
        btnElement.style.color = "black";
        btnElement.style.border = "0";
        btnElement.style.margin = "0 5px";

        watch(showMore, (newV) => {
            el.innerHTML = newV ? text : excerpt.value;
            btnElement.textContent = newV ? "less" : "more";
        });

        btnElement.addEventListener("click", (event) => {
            event.stopPropagation();
            showMore.value = !showMore.value;
        });
    },
};
